// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Zc7Va","content":"styles_content__MW6MJ"};